import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useForm, Controller } from "react-hook-form";
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import {
  addBooking,
  addBuilding,
  addRentalLedgers,
  addUnit,
  updateRentalLedger,
} from "../../../redux/actions/rentalsActions";
import { useParams } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import moment from "moment/moment";
import DatepickerField from "../../Datepicker/DatepickerField";
import styles from "./Ledger.module.css";
import Droper from "../Booking/Droper";
import { updateLedger } from "../../../redux/actions/ledgerAction";
import { payment_type_arr } from "../Constant";

const UpdateLedger = ({
  alertMsg,
  setAlertMsg,
  isHorizontal,
  closePopup,
  initialValues,
  invid,
}) => {
  const [isAboveError, setIsAboveError] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [bookingDate, setBookingDate] = useState({
    date: new Date(),
  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues: initialValues });
  const onSubmit = (data) => {
    data.building_id = Number(initialValues.building_id);
    data.invoice_id = Number(initialValues.invoice_id);
    data.attachment = [...initialValues.attachment] || [];
    console.log(
      { ...data, ...bookingDate, uattachment: [...attachments] },
      "create ledger data"
    );
    const newData = {
      ...data,
      ...bookingDate,
      uattachment: [...attachments],
    };

    setDisabled(true);
    updateRentalLedger(newData).then((res) => {
      console.log(res, "");
      setAlertMsg("Ledger Created successfully");
      setDisabled(false);
    });

    reset({
      type: "",
      amount: "",
      payment_type: "",
      description: "",
    });
    setBookingDate({});
    setAttachments([]);
  };
  function OnChangeDate(name, val) {
    // console.log(val);
    setBookingDate((prev) => ({ ...prev, [name]: val }));
  }

  useEffect(() => {
    setValue("type", initialValues.type);
    // setValue("attachment", initialValues.attachment);
    setValue("amount", initialValues.amount);
    setValue("payment_type", initialValues.payment_type);
    setValue("description", initialValues.description);
  }, [initialValues]);

  return (
    <Grid container>
      <Card>
        <CardContent>
          <Typography variant="h5" component="h5">
            Create Ledger
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/*_____________________________units_name_________________________ */}
            <Grid container spacing={1}>
              <Grid item xs={6}>
                {/*_____________________________ Date _________________________ */}

                <DatepickerField
                  name="Date"
                  className={styles.DateAtt}
                  stl={styles.DateWrapperClass}
                  onChange={(val) => OnChangeDate("move_in", val)}
                  value={new Date(bookingDate.date).toLocaleDateString("en-IN")}
                ></DatepickerField>

                {/*___________________________ Type __________________________ */}
                <FormControl fullWidth sx={{ margin: "9px 0px", mb: "20px" }}>
                  <InputLabel id="demo-simple-select-label">Type</InputLabel>
                  <Controller
                    name="type"
                    control={control}
                    render={({ field: { ref, ...rest } }) => (
                      <Select
                        error={errors.status}
                        labelId="demo-simple-select-label"
                        // sx={{ margin: "9px 0px", mb: "20px" }}
                        id="type"
                        label="Type"
                        variant="outlined"
                        fullWidth
                        {...rest}
                      >
                        {payment_type_arr
                          .map((el, ind) => (
                            <MenuItem value={ind}>{el}</MenuItem>
                          ))
                          .filter((el, ind) => ind !== 0)}
                      </Select>
                    )}
                    rules={{
                      required: "This is required field",
                    }}
                  />
                </FormControl>
                {/*___________________________ amount __________________________ */}
                <Controller
                  name="amount"
                  control={control}
                  render={({ field: { ref, ...rest } }) => (
                    <TextField
                      autoFocus
                      error={errors.deposit}
                      margin="dense"
                      mb="20px"
                      id="amount"
                      label="Amount"
                      type="number"
                      fullWidth
                      variant="outlined"
                      helperText={errors?.amount?.message}
                      {...rest}
                    />
                  )}
                  rules={{
                    required: "This is required field",
                    max: {
                      value: 1000000,
                      message: "value can't exceed 1000000",
                    },
                    min: {
                      value: 0,
                      message: "value can't be negative",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                {/*___________________________ payment_type __________________________ */}
                <FormControl fullWidth sx={{ margin: "9px 0px", mb: "20px" }}>
                  <InputLabel id="demo-simple-select-label">
                    Payment Type
                  </InputLabel>
                  <Controller
                    name="payment_type"
                    control={control}
                    render={({ field: { ref, ...rest } }) => (
                      <Select
                        error={errors.status}
                        labelId="demo-simple-select-label"
                        // sx={{ margin: "9px 0px", mb: "20px" }}
                        id="payment_type"
                        label="payment_type"
                        variant="outlined"
                        fullWidth
                        {...rest}
                      >
                        <MenuItem value="1">Cash</MenuItem>
                        <MenuItem value="2">Online</MenuItem>
                      </Select>
                    )}
                    rules={{
                      required: "This is required field",
                    }}
                  />
                </FormControl>

                {/*___________________________ description __________________________ */}
                <Controller
                  name="description"
                  control={control}
                  render={({ field: { ref, ...rest } }) => (
                    <TextField
                      autoFocus
                      error={errors.description}
                      margin="dense"
                      mb="20px"
                      id="description"
                      label="Description"
                      type="text"
                      fullWidth
                      variant="outlined"
                      helperText={errors?.description?.message}
                      {...rest}
                    />
                  )}
                  rules={{
                    required: "This is required field",
                    // pattern: {
                    //   value: /^[0-9]{10}$/,
                    //   message: "Please enter a valid 10-digit contact number",
                    // },
                  }}
                />
              </Grid>
            </Grid>
            <Box mt={4}>
              <Droper
                value={attachments}
                onChange={(e) => setAttachments(e)}
                uploadLabel={"Upload ID"}
              />
            </Box>
            {/* __________________________________File Picker_________________________*/}

            <ButtonGroup className="form__button-toolbar">
              <Button color="primary" type="submit" disabled={disabled}>
                Update
              </Button>
              <Button
                type="button"
                onClick={() => {
                  closePopup();
                  setIsAboveError(false);
                  reset({
                    type: "",
                    amount: "",
                    payment_type: "",
                    description: "",
                  });
                }}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </form>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default UpdateLedger;
